var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CourseList',{attrs:{"level-key":"beginnerLevel","fetch-action":"getCourseBeginners","getter-name":"courseBeginners"}})
}
var staticRenderFns = []

export { render, staticRenderFns }